export default __webpack_public_path__ + "static/media/retake-recorded-video.6c114e03.svg";